import { StyledShield } from './ShieldStyles';

const Shield = () => {
  return <StyledShield></StyledShield>;
};

export default Shield;
